/** Agent default scale (annotation pixels per metre) used when the page is
 * uncalibrated (pageScale === 0). */
export const DEFAULT_SCALE_PIXELS_PER_METER = 118;

/** Heuristic for provenance placement notes that indicate an ESTIMATED source
 * position — a fallback for cables.json files written before the agent added the
 * explicit `estimated` flag. */
export const ESTIMATED_PLACEMENT_PATTERN =
  /estimat|cent(?:re|er) of the devices|no board|approx|assum|guess|unsure/i;

/** Heuristic: the source dot marks a riser entry on this floor rather than the
 * panel itself (panel is known, but lives on another storey). */
export const RISER_PATTERN = /riser|steigleit/i;

/**
 * How long the run he has just selected stays marked on the plan. Three pulses
 * of `karl-blink` at 0.75s and a little air — long enough to find one run among
 * eighty-three on a sheet he has NOT been zoomed into, and over before he acts
 * on it. It clears itself, so selecting the same run again marks it again.
 */
export const SELECTED_RUN_MARK_MS = 2500;
